import type { FaireProductEntity } from "../../entity_types/product";

export const p_q5qnpb5qzx: FaireProductEntity = {
  token: "p_q5qnpb5qzx",
  type: "product",
  name: "Ice Cream Drip Printed Kids Hoodie",
  brandToken: "b_a42k6qezb7",
  brandName: "sassy kids palace",
  imageUrl:
    "https://cdn.faire.com/fastly/bce329f92716f53a3f4241a561db99d903dce894fd1822b77d27110bdc84ea2a.jpeg",
  galleryImageUrls: [],
  priceDollars: 10.49,
  description:
    "Ice Cream Drip Printed Kids Hoodie\n\n * Top \n * Polyester \n * Sizes:3-6M to 7-8T \n * Machine washable ",
  tags: [],
  msrpDollars: 20.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:00.339Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
